import React from 'react';
import { format } from 'date-fns';
import { Customer } from '../../../core/api/models';
import 'react-widgets/dist/css/react-widgets.css';
import documentList from '../../../utils/documents.json';
import { Dict } from '../../../core/models';
import viewImage from '../../../assets/images/image-holder.png';
import ImageView from '../../../components/image-view/ index';
import companyDocumentList from '../../../utils/companyDocuments.json';
import { DownloadLink } from '../../../components/render-file/DownloadLink';

const DocumentView: React.FunctionComponent<{
  customerDetails?: Customer;
  onEdit: (type: string) => void;
}> = (props) => {
  const [currentImage, setCurrentImage] = React.useState<string>('');
  const getDocumentList = () => {
    return props.customerDetails?.isCompanyCustomer
      ? [...documentList, ...companyDocumentList]
      : [...documentList];
  };
  const renderDownload = (file: any) => {
    return (
      <DownloadLink
        file={file}
        target="_blank"
        className="font-xs font-weight-semibold text-primary cursor-pointer"
      >
        Download
      </DownloadLink>
    );
  };
  return (
    <div className="col-12 col-md-12 font-sm pr-0">
      {getDocumentList()?.map((doc) => {
        const savedDocument: Dict | undefined =
          props.customerDetails && props.customerDetails?.documents
            ? props.customerDetails.documents?.find(
                (x) => x.documentType === doc.type
              )
            : undefined;
        const documentSelected: Dict = (doc.fields as unknown) as Dict;
        return (
          <>
            {savedDocument ? (
              <>
                <div className="row mt-3 position-relative">
                  <h5 className="font-sm text-uppercase">{doc.name}</h5>
                  <span
                    onClick={() => props.onEdit(doc.type)}
                    className="col-auto cursor-pointer d-inline-block font-weight-semibold font-xs mb-3 mb-md-0 position-absolute right-0 text-primary"
                  >
                    <i className="icon-edit"></i>
                  </span>
                </div>
                <div className="border mr-0 p-2 rounded row">
                  {Object.keys(documentSelected).map((key) => {
                    return (
                      <>
                        <div className="col-6 text-gray-500 py-2">
                          {documentSelected[key].label}
                        </div>
                        <div className="col-6 font-weight-semibold py-2">
                          {documentSelected[key].type === 'image' && (
                            <div className="d-flex align-items-center">
                              <img src={viewImage} className="mr-2" alt="" />
                              <span
                                onClick={() =>
                                  setCurrentImage(savedDocument[key]?.location)
                                }
                                className="font-weight-semibold text-decoration-underline text-primary cursor-pointer"
                              >
                                View
                              </span>
                            </div>
                          )}
                          {documentSelected[key].type === 'date' &&
                            savedDocument[key] && (
                              <>
                                {format(
                                  new Date(savedDocument[key]),
                                  'dd/MM/yyyy'
                                )}
                              </>
                            )}

                          {documentSelected[key].type === 'pdf' &&
                            savedDocument[key] && (
                              <>{renderDownload(savedDocument[key])}</>
                            )}
                          {(documentSelected[key].type === 'select' ||
                            documentSelected[key].type === 'text') &&
                            typeof savedDocument[key] !== 'object' &&
                            savedDocument[key] && <>{savedDocument[key]}</>}
                        </div>
                      </>
                    );
                  })}
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        );
      })}
      {currentImage && (
        <ImageView
          imageUrl={currentImage}
          onClose={() => setCurrentImage('')}
        ></ImageView>
      )}
    </div>
  );
};

export default DocumentView;
